import { untrack } from "svelte";
import type {
  DomAnimationHelper,
  StepsDefinition,
} from "@otto-ec/otto-components-utils/svelte/useDomAnimationHelper";
import { commitPopPush, stack } from "../stack/stack.global.svelte";
import { sheetClose, sheetGoBack, sheetOpenById } from "../apis/methods.js";
import { stackScope } from "../stack/stack.utils";
import type { OcSheetV1VisibilityState } from "./visibility.svelte";

const log = /*           */ stackScope.scope("instance");
const logSynchronizer = /*           */ stackScope.scope("synchronizer");
const logVisibility = /*           */ log.scope("visibility");

export interface OcSheetV1InstanceState {
  /**
 *
 *
 */
  isCurrent: boolean;
  /**
 *
 *
 */
  isReady: boolean;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useSheetStack = (
  init: {
    id: () => string;
    open: () => boolean | undefined;
    activation: (isActive: boolean) => void;
  },
  visibilityState: OcSheetV1VisibilityState,
  setVisibility: DomAnimationHelper<StepsDefinition>[1],
): OcSheetV1InstanceState => {
  const state = $state<OcSheetV1InstanceState>({
    isCurrent: false,
    isReady: false,
  });

  /*                                                         */
  $effect(() => {
    const sheetId = init.id();
    const wantsOpen = init.open();
    const isCurrent = untrack(() => state.isCurrent);

    /*                                               */
    if (wantsOpen === isCurrent) {
      if (import.meta.env.DEV)
        log.debug("Instance already in wants open state", sheetId, wantsOpen);
      return;
    }

    if (wantsOpen) {
      if (import.meta.env.DEV) log.info("open instance", sheetId);
      sheetOpenById(sheetId);
    } else if (untrack(() => stack.contentChange)) {
      if (import.meta.env.DEV) log.info("pop instance", sheetId);
      sheetGoBack();
    } else {
      if (import.meta.env.DEV) log.info("close instance", sheetId);
      sheetClose();
    }
  });

  /*                                                                       */
  /*                                                         */
  $effect(() => {
    const sheetId = init.id();
    const isCurrent = stack.current === init.id();

    /*                                                                       */
    /*                                                                               */
    if (isCurrent === state.isCurrent) {
      if (import.meta.env.DEV)
        log.debug("Instance already in is current state", sheetId, isCurrent);
      return;
    }

    if (import.meta.env.DEV) log.info("Set instance isCurrent", sheetId, isCurrent);
    state.isCurrent = isCurrent;

    /*                                     */
    if (import.meta.env.DEV) logSynchronizer.info("Instance isCurrent changed", sheetId, isCurrent);
    init.activation(isCurrent);
  });

  $effect(() => {
    const { isCurrent, isReady } = state;
    const sheetId = untrack(init.id);

    if (import.meta.env.DEV)
      logVisibility.debug("Instance visibility state", sheetId, {
        isCurrent,
        isReady,
        contentChange: stack.contentChange,
      });

    /*                                                                                 */
    /*                                                                  */
    if (isCurrent && (isReady || stack.contentChange)) {
      if (import.meta.env.DEV)
        logVisibility.info("set true", sheetId, "immediate:", stack.contentChange);

      /*                                                                        */
      setVisibility(true, { immediate: stack.contentChange });
    } else if (!state.isCurrent) {
      if (import.meta.env.DEV)
        logVisibility.info("set false", sheetId, "immediate:", stack.contentChange);

      /*                                                                        */
      setVisibility(false, { immediate: stack.contentChange });
    }
  });

  /*                                                                   */
  $effect(() => {
    if (visibilityState.$direction === undefined) untrack(commitPopPush);
  });

  return state;
};
